
import { JwtStore } from '@/store/modules';
import { Component, Vue } from 'vue-property-decorator';

import QvInput from '@/components/FormComponents/QvInput.vue';
import { ValidationObserver } from 'vee-validate';
import { ConfirmResetPassword } from '@/store/models/jwt';

@Component({
  components: {
    ValidationObserver,
    QvInput
  },
  meta: {
    title: 'Forgot Password'
  }
})
export default class PasswordReset extends Vue {
  payload: ConfirmResetPassword = {} as ConfirmResetPassword;

  isConfirmPwd = true;
  isPwd = true;

  created() {
    this.payload.uid = this.$route.params.uid;
    this.payload.token = this.$route.params.token;
  }

  onSubmit() {
    JwtStore.confirmResetPassword(this.payload).then(response => {
      if (response.message) {
        this.$q.notify({
          type: 'positive',
          message: `${response.message}`,
          timeout: 5000
        });
      }
      this.$router.push({ name: 'Home' });
    });
  }
}
